import { SpreadChartOfAccounts } from "../spread/types";
import { SpreadPeriod } from "../spread/types";
import { AccountPresenter, ChartOfAccountsPresenter } from "./types";

const generateChartOfAccountsPresenter = (
  chartOfAccountsFromBackend: SpreadChartOfAccounts,
  periods: SpreadPeriod[],
  children: AccountPresenter[]
): ChartOfAccountsPresenter => ({
  id: chartOfAccountsFromBackend.id,
  name: chartOfAccountsFromBackend.name,
  type: "ROOT",
  periods,
  children
});

export default generateChartOfAccountsPresenter;



// WEBPACK FOOTER //
// ./src/spread/model/presenter/generateChartOfAccountsPresenter.ts